import Quill from 'quill';

const BlockEmbed = Quill.import('blots/block/embed');

export class ImageWithCaptionBlot extends BlockEmbed {
  static blotName = 'image'; // переопределяем стандартный
  static tagName = 'figure';
  static className = 'image-with-caption';

  static create(value: string | { source: string; caption?: string }) {
    const node = super.create();

    let source: string;
    let caption: string | undefined;

    if (typeof value === 'string') {
      try {
        const parsed = JSON.parse(value);
        source = parsed?.source ?? '';
        caption = parsed?.caption ?? '';
      } catch {
        source = value;
        caption = '';
      }
    } else {
      source = value.source;
      caption = value.caption ?? '';
    }

    // Картинка
    const img = document.createElement('img');
    img.setAttribute('src', source);
    img.style.maxWidth = '100%';
    img.style.display = 'block';
    node.appendChild(img);

    // Подпись
    if (caption) {
      const captionDiv = document.createElement('div');
      captionDiv.className = 'caption';
      captionDiv.setAttribute('contenteditable', 'false');
      captionDiv.innerText = caption;
      captionDiv.style.color = '#666';
      captionDiv.style.fontSize = '0.9em';
      captionDiv.style.marginTop = '4px';
      node.appendChild(captionDiv);
    }

    node.dataset.source = source;
    node.dataset.caption = caption;

    return node;
  }

  static value(node: HTMLElement) {
    const source = node.dataset.source ?? '';
    const caption = node.dataset.caption ?? '';
    return JSON.stringify({ source, ...(caption ? { caption } : {}) });
  }
}

Quill.register(ImageWithCaptionBlot, true);
